/* Generated by scripts/apply-brand.js — do not edit by hand */
/** Every brand folder under brands/. */
export const BRAND_IDS = ["dentistryq","gpqbank","icmqs","mastersrh","medicineqs","ogqbank","ophthalmologyq","psychqs","solicitorqs","surgeryqs"] as const;
export type BrandId = (typeof BRAND_IDS)[number];

/** CRA inlines this at build time; falls back to brand.marketingUrl when unset. */
export const marketingUrlFromEnv: string | undefined = process.env.REACT_APP_MARKETING_URL_GPQBANK;

export const brand = {
  id: "gpqbank",
  displayName: "GPQBank",
  appUrl: "https://app.gpqbank.com",
  marketingUrl: "https://gpqbank.com",
  contactEmail: "gpqbank@gmail.com",
  metaDescription: "MSRA and MRCGP AKT question banks for GP trainees—clinical MCQs, SJTs, and AKT-style practice.",
  footerDescriptionHtml: "<strong>MSRA</strong> and <strong>MRCGP AKT</strong> question banks for GP trainees—clinical MCQs, SJTs, and AKT-style practice. <strong>Co-founded by a medic for GPs.</strong>",
  signupKeyFeatures: ["Co-founded by a medic for GPs","Extensive content with 1000s of questions overall","Covers MSRA and MRCGP AKT","Regular updates to platform and questions"],
  s3Bucket: "app.gpqbank.com",
  productIds: ["msra","mrcgp_akt"],
  colors: {
    primary: "#8b1e1e",
    primaryHover: "#6b1515",
    navy: "#3d0e0e",
    navyDeep: "#2a0808",
    navyMid: "#5c1212",
    accent: "#9b2424",
    accentAlt: "#a82828",
    stats: "#8b1e1e",
    statsHover: "#5c1212",
    footer: "#3d0e0e",
    footerDeep: "#2a0808",
    footerLight: "#5c1212",
    footerMuted: "#1a0505",
  },
} as const;

export type Brand = typeof brand;
